import { ReactNode } from "react";

import { clsxMerge } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

import { Container } from "@/components/base/container";
import { useUser } from "@/hooks/use-global-context";
import { V3PageHeaderComponents } from "./components";
import { DocsTriggerButton } from "@/components/shared/docs/docs-trigger-button";
import { DocsPathI } from "shared/lib/interfaces/docs";

interface PrimaryNavigationPageHeaderPropsI extends PropsWithClassNameI {
  title: ReactNode;
  isCurrentTimeVisible?: boolean;
  docsPath?: DocsPathI;
}

export const PrimaryNavigationPageHeader = ({
  className,
  title,
  isCurrentTimeVisible = false,
  docsPath,
}: PrimaryNavigationPageHeaderPropsI) => {
  const user = useUser();

  return (
    <Container className={clsxMerge("relative lg:w-full", className)}>
      <div className="navbar flex min-h-[45px] justify-between px-0 pb-5 pt-7">
        <div className="flex w-full items-center">
          <div className="flex items-start">
            <V3PageHeaderComponents.Title user={user} title={title} />
            {docsPath && (
              <DocsTriggerButton className="-mt-1 ml-2" {...docsPath} />
            )}
          </div>

          <V3PageHeaderComponents.LiveTime
            title={title}
            isVisible={isCurrentTimeVisible}
          />
        </div>
      </div>
    </Container>
  );
};
